import React, { useState } from "react";
import { primaryColor } from "../../utilities/colors";
import { useLanguage } from "../LangTranslation/LanguageContext";
import sampleTemplate from "../../assets/files/Final_v1_Product_Template_sample.xlsx";
import ReactSelect from "react-select";
import Background from "../../Images/Background.jpg";
import { usePolling } from "../../contexts/PollingContext";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.hasValue ? "black" : "white", // Background for closed dropdown
    color: state.hasValue ? "#baf76a" : "black", // Optional: Adjust text color inside control
    borderColor: state.isFocused ? "#baf76a" : "black", // Border when focused
    boxShadow: state.isFocused ? "0 0 0 1px #baf76a" : "none", // Focused state shadow
    borderRadius: 12,
    "&:hover": {
      borderColor: "#baf76a", // Border color on hover
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 12, // Rounded corners for the dropdown menu
    textAlign: "center",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#baf76a", // Text color of the selected option in the input field
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "black"
      : state.isFocused
      ? "rgba(186, 247, 106, 0.25)"
      : "white",
    color: state.isSelected ? "#baf76a" : "black", // Text color for selected/unselected options
    borderRadius: 8, // Rounded corners for the dropdown menu
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#baf76a", // Arrow color
    "&:hover": {
      color: "#baf76a", // Arrow color on hover
    },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "#baf76a", // Optional: Hide the separator line
  }),
};

const ProductWizard = ({ onClose, handleCreateClick, handleImportModal }) => {
  const [uploadType, setUploadType] = useState("single");
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { isPolling } = usePolling();
  const categories = [
    { category: `${t["Download Sample CSV"]}`, template: sampleTemplate },
    // { category: "Fashion", template: sampleTemplate },
    // { category: "Clothes", template: sampleTemplate },
    // { category: "Health Care", template: sampleTemplate },
  ];
  const productUploadTypeListOption = [
    { label: `${t["Create Single Product"]}`, value: "single" },
    { label: `${t["Bulk Upload Product"]}`, value: "multiple" },
  ];
  const [productUploadType, setProductUploadType] = useState(
    productUploadTypeListOption[0]
  );

  const handleChangeproductUploadType = (value) => {
    setUploadType(value.value);
    setProductUploadType(value);
  };

  const downloadFile = (category) => {
    const fileUrl = category.template;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = category.category + ".xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div className="me-4 my-4" style={{ minHeight: "290px" }}>
      <div className="d-flex align-items-center justify-content-between mt-4 modal-header">
        <h4 className="text-secondary fw-bold">{t["Product Wizard"]}</h4>
        <a
          className="text-danger"
          onClick={onClose}
          style={{ cursor: "pointer" }}
        >
          <i className="bi bi-x-square-fill"></i>
        </a>
      </div>

      <div className="d-flex flex-column-reverse flex-sm-row">
        <div className="w-100 w-sm-50 p-3">
          {uploadType === "single" && (
            <div className="required-info-wrapper d-flex flex-column justify-content-start mx-3 mt-4">
              <h4 className="fw-bold" style={{ fontFamily: "Comfortaa" }}>
                Required Information for product creation
              </h4>
              <div className="d-flex">
                <ul style={{ fontFamily: "Comfortaa" }}>
                  <li className="fw-bold">Name</li>
                  <li className="fw-bold">Image</li>
                  <li className="fw-bold">Price</li>
                  <li className="fw-bold">Cost</li>
                  <li className="fw-bold">Category</li>
                  <li className="fw-bold">Brand</li>
                </ul>
                <ul style={{ fontFamily: "Comfortaa" }}>
                  <li className="fw-bold">Weight</li>
                  <li className="fw-bold">Barcode</li>
                  <li className="fw-bold">HS Code</li>
                  <li className="fw-bold">Height</li>
                  <li className="fw-bold">Width</li>
                  <li className="fw-bold">Length</li>
                </ul>
              </div>
              <button
                className="btn btn-sm vtex-btn"
                onClick={handleCreateClick}
                style={{
                  background: "#000000",
                  color: primaryColor.primary,
                  //   marginLeft: "1.5rem",
                  //   marginRight: "1.5rem",
                  height: "44px",
                  borderRadius: "15px",
                }}
              >
                + {t["New Product"]}
              </button>
            </div>
          )}
          {uploadType === "multiple" && (
            <div className="required-doc-wrapper d-flex flex-column justify-content-start mx-3 mt-4">
              <h4 className="fw-bold" style={{ fontFamily: "Comfortaa" }}>
                {t["Ensure you follow the template to avoid issues"]}
              </h4>
              {/* <small className="text-muted fst-italic d-block">
                Hint: Ensure you follow the template to avoid issues
              </small> */}
              <ul
                style={{
                  fontFamily: "Comfortaa",
                }}
              >
                {categories.map((category) => (
                  <li
                    key={category.category}
                    className="fw-bold cursor-pointer businessCateg"
                    title={"download " + category.category + " template"}
                    onClick={() => downloadFile(category)}
                  >
                    {category.category}
                  </li>
                ))}
              </ul>
              <button
                className="btn btn-sm vtex-btn"
                disabled={isPolling}
                onClick={handleImportModal}
                style={{
                  background: "#000000",
                  color: primaryColor.primary,
                  //   marginLeft: "1.5rem",
                  //   marginRight: "1.5rem",
                  height: "44px",
                  borderRadius: "15px",
                }}
              >
                <i className="bi bi-file-earmark-arrow-up-fill"></i>{" "}
                {t["Import Products"]}
              </button>
            </div>
          )}
        </div>
        <div
          className="d-flex flex-column justify-content-center align-items-center w-100 w-sm-50 gap-3 p-3"
          style={{
            backgroundImage: `url(${Background})`,
            backgroundSize: "cover",
            backgroundPosition: "initial",
            backgroundRepeat: "no-repeat",
          }}
        >
          <h4 className="fw-bold" style={{ fontFamily: "Comfortaa" }}>
            {t["Product Upload Options:"]}
          </h4>
          <ReactSelect
            value={productUploadType}
            options={productUploadTypeListOption}
            name="type"
            onChange={handleChangeproductUploadType}
            styles={customStyles}
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary25: "rgba(186, 247, 106, 0.25)",
                primary: "black",
              },
            })}
          />
          {/* <input
            type="radio"
            class="btn-check vtex-btn-check"
            name="options"
            id="single"
            autocomplete="off"
            checked={uploadType === "single"}
            onChange={() => setUploadType("single")}
          />
          <label
            className="btn vtex-btn"
            style={
              uploadType === "single"
                ? {
                    background: "#000000",
                    color: primaryColor.primary,
                    // marginLeft: "1.5rem",
                    // marginRight: "1.5rem",
                    // height: "44px",
                    borderRadius: "15px",
                    height: "fit-content",
                  }
                : {
                    background: "transparent",
                    color: "#000000",
                    // marginLeft: "1.5rem",
                    // marginRight: "1.5rem",
                    // height: "44px",
                    borderRadius: "15px",
                    border: "1px solid #cccccc",
                    height: "fit-content",
                  }
            }
            htmlFor="single"
          >
            Single Product Creation
          </label>

          <input
            type="radio"
            class="btn-check vtex-btn-check"
            name="options"
            id="multiple"
            autocomplete="off"
            checked={uploadType === "multiple"}
            onChange={() => setUploadType("multiple")}
          />
          <label
            className="btn vtex-btn"
            style={
              uploadType === "multiple"
                ? {
                    background: "#000000",
                    color: primaryColor.primary,
                    // marginLeft: "1.5rem",
                    // marginRight: "1.5rem",
                    // height: "44px",
                    borderRadius: "15px",
                    height: "fit-content",
                  }
                : {
                    background: "transparent",
                    color: "#000000",
                    // marginLeft: "1.5rem",
                    // marginRight: "1.5rem",
                    // height: "44px",
                    borderRadius: "15px",
                    border: "1px solid #cccccc",
                    height: "fit-content",
                  }
            }
            htmlFor="multiple"
          >
            Bulk Product Upload
          </label> */}
        </div>
      </div>
    </div>
  );
};

export default ProductWizard;
